var Vendd = (function (Vendd) {
    'use strict';

    Vendd.WishlistMerchant = (function (WishlistMerchant) {

        WishlistMerchant.Messages = (function (Messages) {

        Messages.Add = function (id, path, extraAttributes, bundleItems) {
            var data = {
                id: id,
                path: path,
                extraAttributes: extraAttributes, //example: extraAttributes: [{code:'test',value:'testValue'}]
                bundleItems: bundleItems //example: bundleItems: [{parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.WishlistMerchant.Messages.Add", data);
        };
        Messages.Add.className = "Vendd.WishlistMerchant.Messages.Add";

        Messages.AddSuccess = function (response) {
            response.data = JSON.parse(response.data);
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WishlistMerchant.Messages.AddSuccess', response);
        };
        Messages.AddSuccess.className = 'Vendd.WishlistMerchant.Messages.AddSuccess';

        Messages.Remove = function (id) {
            var data = {
                id: id
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.WishlistMerchant.Messages.Remove", data);
        };
        Messages.Remove.className = "Vendd.WishlistMerchant.Messages.Remove";

        Messages.Clear = function () {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.WishlistMerchant.Messages.Clear");
        };
        Messages.Clear.className = "Vendd.WishlistMerchant.Messages.Clear";

        Messages.Changed = function (model) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WishlistMerchant.Messages.Changed', model);
        };
        Messages.Changed.className = 'Vendd.WishlistMerchant.Messages.Changed';

        Messages.GetModel = function () {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WishlistMerchant.Messages.GetModel');
        };
        Messages.GetModel.className = 'Vendd.WishlistMerchant.Messages.GetModel';

        Messages.Failed = function (response) {
            response.data = JSON.parse(response.data);

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WishlistMerchant.Messages.Failed', response);
        };
        Messages.Failed.className = 'Vendd.WishlistMerchant.Messages.Failed';

        return Messages;

    })(WishlistMerchant.Messages || {});

        return WishlistMerchant;

    })(Vendd.WishlistMerchant || {});

return Vendd;

})(Vendd || {});